export default {
  allowAttachments: false,
  allowAttribute: false,
  allowButton: false,
  allowCode: false,
  allowEmoji: true,
  allowHeading: false,
  allowImage: true,
  allowSocial: false,
  allowSubheading: false,
  allowUploads: false,
  allowVideo: true,
  attributeInserter: false,
  markdownLinks: false
};